/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Modal } from '../modal/modal';
import { useForm } from 'react-hook-form';
import { CheckboxTypeInput } from '../forms/checkbox-type-input';
import { useTranslation } from 'react-i18next';
import { UserLimit } from '../../models/enumerations/user-limit';
import { LicenseLimit } from '../../models/enumerations/license-limit';
interface CancellationDialogBoxProps {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: Function;
  isLoading?: boolean;
}

const COMPONENT_CLASS = "c-cancellation-dialog-box";

const DowngradeModal: React.FC<CancellationDialogBoxProps> = (props) => {
  const {
    isOpen,
    onClose,
    onSubmit,
    isLoading,
  } = props;

  const methods = useForm<any>();

  const {
    register,
  } = methods;

  const [checkedBoxesNumber, setCheckedBoxesNumber] = useState(0);
  const { t } = useTranslation();
  const [checkboxes, setCheckboxes] = useState([
    { firstLine: t('billing.downgrade.chk_1_title', { userNumber: UserLimit.Core }), secondLine: t('billing.downgrade.chk_1_desc', { userNumber: UserLimit.Core }), isChecked: false },
    { firstLine: t('billing.downgrade.chk_2_title', { wpNumber: LicenseLimit.Core }), secondLine: t('billing.downgrade.chk_2_desc', { wpNumber: LicenseLimit.Core }), isChecked: false },
  ])

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const { checked } = e.target;
    const newCheckBoxes = [...checkboxes]
    newCheckBoxes[index].isChecked = checked
    setCheckboxes(newCheckBoxes);

    if (checked) {
      setCheckedBoxesNumber(checkedBoxesNumber + 1);
    }
    else {
      setCheckedBoxesNumber(checkedBoxesNumber - 1);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      isLoading={isLoading || false}
      onClose={onClose}
      defaultModalActions={true}
      submitButtonText={t('buttons.btn_agreeAndDowngrade')}
      cancelButtonText={t('buttons.btn_keepSubscription')}
      onSubmit={async () => {
        onSubmit();
        onClose(false);
      }}
      onCancel={() => onClose(false)}
      submitDisabled={checkedBoxesNumber !== checkboxes.length}>
      <div className={COMPONENT_CLASS}>
        <h3>{t('billing.downgrade.title')}</h3>

        <p className={`${COMPONENT_CLASS}__description`} dangerouslySetInnerHTML={{ __html: t('billing.downgrade.description') }}></p>

        <div className={`${COMPONENT_CLASS}__checkboxes`}>
          {checkboxes.map((checkbox, index) => {
            return (
              <div key={index} className={`${COMPONENT_CLASS}__checkbox-row`}>
                <div className={`${COMPONENT_CLASS}__checkbox-wrapper`}>
                  <CheckboxTypeInput
                    id={`${COMPONENT_CLASS}__checkbox-${index}`}
                    inputClassName={`${COMPONENT_CLASS}__cancel-subscription-checkbox`}
                    registerHook={register}
                    registerOptions={{
                      onChange: (e) => handleCheckboxChange(e, index)
                    }}
                    checked={checkbox.isChecked} />
                </div>
                <label htmlFor={`${COMPONENT_CLASS}__checkbox-${index}`}>
                  <p><strong>{checkbox.firstLine}</strong></p>
                  <p>{checkbox.secondLine}</p>
                </label>
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );

};

export default DowngradeModal;